import SectionHeading from "./SectionHeading";

const principles = [
  { icon: "ri-scales-3-line", title: "客观中立", desc: "评分与推荐基于主流反馈整理，坚持独立编辑，不被商业流量绑架。" },
  { icon: "ri-search-eye-line", title: "认真选片", desc: "每一部入选影片都经过编辑部人工筛选与内容核对，拒绝标题党。" },
  { icon: "ri-shield-check-line", title: "尊重版权", desc: "倡导正规渠道观影，不提供任何盗版下载与侵权在线资源。" },
  { icon: "ri-refresh-line", title: "高频更新", desc: "档期、新片与片单保持高频率刷新，让资讯始终跟得上潮流。" },
];

const quotes = [
  {
    text: "以前找片总要翻好几个平台，现在吃瓜影院一个地方就能把新片和片单都看明白，省心多了。",
    who: "影迷 · 阿哲",
    tag: "日常影迷",
  },
  {
    text: "编辑精选的周末片单质量很高，踩雷率很低，已经安利给好几个朋友了。",
    who: "影迷 · 小满",
    tag: "剧集+电影",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="section-pad scroll-mt-20 bg-background-50">
      <div className="container-x grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-16">
        <div>
          <SectionHeading
            eyebrow="关于我们"
            title="把找电影这件小事，做得更靠谱"
            desc="吃瓜影院诞生于一个朴素的念头：好电影不该被信息洪流淹没，找片也不该让人发愁。"
          />
          <div className="mt-6 space-y-4 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
            <p>
              我们是一群爱看电影的编辑。在这里，你会看到经过挑选的最新电影、分类清晰的题材片库、不同场景下的编辑片单，以及对影片客观务实的介绍与口碑参考。
            </p>
            <p>
              我们不做盗版搬运，也不夸大流量话题。我们相信，一部好的影片资讯网站，应该先帮助你看懂电影，再引导你用正规、舒适的方式去欣赏它。愿每一次点开，都能遇到对味的那一部。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-2 gap-4">
            {principles.map((p) => (
              <div key={p.title} className="rounded-2xl border border-background-200 bg-background-100 p-4 md:p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                  <i className={p.icon + " text-xl"} aria-hidden="true"></i>
                </span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-[13px]">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col">
          <div className="relative overflow-hidden rounded-2xl border border-background-200 bg-gradient-to-br from-primary-800 via-primary-700 to-accent-700 p-7 md:p-9">
            <span className="absolute -right-6 -top-6 text-[120px] text-white/10"><i className="ri-film-fill" aria-hidden="true"></i></span>
            <p className="relative font-heading text-2xl font-black leading-relaxed text-white md:text-3xl">
              “找片不愁，
              <br />
              每一部好电影都值得被看见。”
            </p>
            <p className="relative mt-4 text-sm text-white/75">—— 吃瓜影院编辑组</p>
          </div>

          <div className="mt-6 grid gap-4">
            {quotes.map((q) => (
              <figure key={q.who} className="rounded-2xl border border-background-200 bg-background-100 p-5 md:p-6">
                <div className="flex items-center gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{q.text}”</blockquote>
                <figcaption className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-secondary-200 text-secondary-900">
                    <i className="ri-user-3-line" aria-hidden="true"></i>
                  </span>
                  {q.who}
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5">{q.tag}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}